import _cloneDeep from 'lodash/cloneDeep';

export default class TabsController {
    /** @ngInject */
    constructor($log, EventEmitter) {
        this.$log = $log;
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.selectedTabId = 0;

        if (!this.tabs) {
            this.tabs = [];
        }
    }

    $onChanges(changes) {
        if (changes.tabs) {
            this.findOneToBeActivated(_cloneDeep(changes.tabs.currentValue));
        } else {
            this.tabs = [];
        }
    }

    findOneToBeActivated(tabs) {
        let selectedTabId = null;
        let selectedTabObject = null;
        let selectedMenuItemObject = null;
        let isMenuItem = false;

        this.tabs = tabs;

        const tabsLength = tabs.length;
        for (let i = 0; i < tabsLength; ++i) {
            const tab = tabs[i];
            if ('activate' in tab) {
                selectedTabId = i;
                selectedTabObject = tab;
                delete tab.activate;

                break;
            }

            if ('items' in tab && tab.items.length) {
                const itemsLength = tab.items.length;
                for (let c = 0; c < itemsLength; ++c) {
                    const view = tab.items[c];
                    if ('activate' in view) {
                        selectedTabId = i;
                        selectedTabObject = tab;
                        selectedMenuItemObject = view;
                        isMenuItem = true;
                        delete view.activate;

                        break;
                    }
                }
            }
        }

        this.emulateItemSelection(selectedTabObject, selectedTabId, selectedMenuItemObject, isMenuItem);
    }

    emulateItemSelection(selectedTabObject, selectedTabId, selectedMenuItemObject, isMenuItem) {
        if (null !== selectedTabId) {
            if (isMenuItem) {
                this.onMenuItemClick(selectedTabObject, selectedTabId, selectedMenuItemObject, false);
            } else {
                this.selectedTabId = selectedTabId;
                this.onClick(selectedTabObject, false);
            }
        }
    }

    onClick(tab, $event) {
        this.itemHandler('click', tab, $event);
    }

    onSelect(tab, $event) {
        this.itemHandler('select', tab, $event);
    }

    onDeselect(tab, $event) {
        this.itemHandler('deselect', tab, $event);
    }

    onMenuItemClick(tab, tabId, item, $event) {
        this.selectedTabId = tabId;
        this.menuItemHandler('menu-item-click', tab, item, $event);
    }

    itemHandler(action, tab, $event) {
        const actions = {
            'click': (config) => {
                const handler = config.handler;
                const type = typeof handler;

                if (type === 'function') {
                    handler();
                } else {
                    this.onTabClick(this.eventEmitter({ tab, event: $event }));
                }
            },
            'select': (config) => {
                const handler = config.handler;
                const type = typeof handler;

                if (type === 'object' && 'select' in handler) {
                    handler.select();
                } else {
                    this.onTabSelect(this.eventEmitter({ tab, event: $event }));
                }
            },
            'deselect': (config) => {
                const handler = config.handler;
                const type = typeof handler;

                if (type === 'object' && 'deselect' in handler) {
                    handler.deselect();
                } else {
                    this.onTabDeselect(this.eventEmitter({ tab, event: $event }));
                }
            },
            'default': (config, unspecifiedAction) => {
                this.$log.warn(`DT-TABS: Provided unspecified action for item '${config.title}': ${unspecifiedAction}`);
            }
        };

        (actions[action] || actions.default)(tab, action);
    }

    menuItemHandler(action, tab, item, $event) {
        const actions = {
            'menu-item-click': (config) => {
                const handler = config.handler;
                const type = typeof handler;

                if (type === 'function') {
                    handler();
                } else {
                    this.onTabMenuItemClick(this.eventEmitter({ tab, item, event: $event }));
                }
            },
            'default': (config, unspecifiedAction) => {
                this.$log.warn(`DT-TABS: Provided unspecified action for item '${config.title}': ${unspecifiedAction}`);
            }
        };

        (actions[action] || actions.default)(tab, action);
    }
}



// WEBPACK FOOTER //
// ./app/common/navbar/tabs/tabs.controller.js